import { ReactNode, useReducer } from "react";

import { DispatchContext, initialState, reducer, State, StateContext } from "./reducer";

export function ToolbarProvider({
    children,
    initialState: customInitialState,
}: {
    children: ReactNode;
    initialState?: State;
}) {
    const [state, dispatch] = useReducer(reducer, customInitialState ?? initialState);

    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
        </StateContext.Provider>
    );
}
